// Entry point PWA.
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App.jsx';
// V3 słaby zasięg B-1 (B9): flaga Trybu lokalnego z IDB PRZED pierwszym renderem
// (apiFetch/processQueue czytają ją synchronicznie). Błąd IDB = tryb wyłączony.
import { initLocalMode } from './services/localMode.js';
// UZUPEŁNIENIE 2 (12.09): znacznik ostatniego sukcesu wysyłki z IDB (stopka + zator w banerze).
import { initQueueHealth } from './services/queueHealth.js';
// E3a (monit 1207R zad. 11/12): jeden host toastów dla całej aplikacji (zero alert()).
import ToastHost from './components/ui/ToastHost.jsx';
// B-1b (13.09.2026, MONIT 1750): deviceId + etykieta z IDB przed renderem (stopka/Serwis),
// ErrorBoundary (FAZA A: nie było), globalne haki błędów (F5), kontrola wersji + puls (F3/F4).
import { initFleet, installGlobalErrorHandlers, noteUploadEvent } from './services/fleet.js';
import { initVersionCheck } from './services/versionCheck.js';
import { uploadManager } from './services/uploadManager.js';
import AppErrorBoundary from './components/ui/AppErrorBoundary.jsx';

// Register Service Worker (tylko w produkcji — dev używa HMR)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .catch((err) => console.warn('SW register failed:', err));
  });
}

// Render nie czeka na sieć (SW serwuje shell z cache); czeka tylko na dwa odczyty IDB
// (ms), z twardym limitem 1,5 s — gdyby IDB było zablokowane, apka i tak startuje.
Promise.race([
  Promise.all([
    initLocalMode().catch(() => false),
    initQueueHealth().catch(() => null),
    initFleet().catch(() => null),
  ]),
  new Promise((r) => setTimeout(r, 1500)),
]).then(() => {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
      <ToastHost />
    </React.StrictMode>
  );
  // Po renderze (nie blokuje startu): haki błędów + kontrola wersji + puls floty
  // + seria nieudanych wysyłek (F5 wyzwalacz 3) ze zdarzeń uploadManagera.
  installGlobalErrorHandlers();
  uploadManager.subscribe((ev) => noteUploadEvent(ev));
  setTimeout(() => { initVersionCheck().catch(() => {}); }, 300);
});
